import { render, staticRenderFns } from "./target-widget.vue?vue&type=template&id=5348152f&scoped=true&"
import script from "./target-widget.vue?vue&type=script&lang=js&"
export * from "./target-widget.vue?vue&type=script&lang=js&"
import style0 from "./target-widget.vue?vue&type=style&index=0&id=5348152f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348152f",
  null
  
)

export default component.exports